import React from 'react'
import { ReactComponent as AvataSvg} from '../../assets/svgs/clients/Avata.svg';

const AvataLogo = () => (
    <div>
        <AvataSvg/>
    </div>
)

export default AvataLogo